<template>
  <div class="main">
    <div class="top">
      <div class="item" @click="toStatisticalLearning('hep')">帮助中心</div>
      <div>|</div>
      <div class="item" @click="toStatisticalLearning('cont')">联系我们</div>
      <div>|</div>
      <div class="item" @click="toStatisticalLearning('abou')">关于我们</div>
      <div>|</div>
      <div class="label">
        <div class="text">服务热线:</div>
        {{ data.mobile }}
      </div>
      <div class="label">
        <div class="text">Email:</div>
        {{ data.email }}
      </div>
      <div class="tencent-group"><span class="text">|QQ交流群：</span>{{ data.qq }}</div>
      <div class="qrcode" @click="popclick(path + data.wechat)"><img :src="path + data.wechat" />
        <div>关注微信</div>
      </div>
    </div>
    <div class="bottom">{{ data.copy_right }}</div>
    <Modal v-model="popclickShow" @on-cancel="popclickShow = false">
      <Row style="line-height:3;max-height:600px;overflow:auto">
        <img style="width:80%;margin:0 auto" :src="popclickimg" alt="">
      </Row>
      <div slot="footer">
        <Button type="text" size="small" @click="popclickShow = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        data: {
        },
        popclickShow: false,
        popclickimg: ''
      }
    },
    components: {},
    computed: {},
    mounted() {
      this.getline()
    },
    methods: {
      popclick(img) {
        this.popclickimg = ''
        this.popclickShow = true
        this.popclickimg = img
      },
      toStatisticalLearning(name) {
        this.$store.commit('global/SET_LABEL_MSG', name)
        this.$router.push('/statisticalLearning')
      },
      getline() {
        this.$axios
          .post('/app/auth/getWebInfo')
          .then((res) => {
            if (res.code == 1) {
              this.data = res.data
            }
          });
      },
    }
  }
</script>
<style scoped lang="less">
  .main {
    width: 100%;
    height: 16vh;
    background: #333435;
    border-top: 8px solid rgb(216, 150, 6);
    padding-left: 10vw;
    font-size: 16px;
    color: #fff;
    clear: both;
    .top {
      display: flex;
      margin-top: 3vh;
      .label {
        display: flex;
        .text {
          margin-left: 1vw;
          margin-right: .6vw;
          text-align: center;
        }
      }
      .tencent-group {
        margin-left: 6vw;
        .text {
          display: inline-block;
          margin-top: -1vh;
          font-size: 20px;
        }
      }
      .item {
        width: 6vw;
        text-align: center;
        cursor: pointer;
      }
    }
    .bottom {
      margin-top: -6vh;
      margin-left: 14vw;
    }
    .qrcode {
      margin-left: 10vw;
      margin-top: -2vh;
      cursor: pointer;
      text-align: center;
      img {
        width: 11vh;
        height: 11vh;
      }
    }
  }
</style>
